import { render, staticRenderFns } from "./OpponentScreen.vue?vue&type=template&id=5341a088&scoped=true&"
import script from "./OpponentScreen.vue?vue&type=script&lang=js&"
export * from "./OpponentScreen.vue?vue&type=script&lang=js&"
import style0 from "./OpponentScreen.vue?vue&type=style&index=0&id=5341a088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341a088",
  null
  
)

export default component.exports